import React, { useState, useEffect } from "react";
import styles from './product_info_bar.module.css';



const ProductInfoBar = ({ product, variant }) => {

  const [activeButton, setActiveButton] = useState('description');
  const [programList, setProgramList] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [certificateList, setCertificateList] = useState([]);
  const [descriptionsList, setDescriptionsList] = useState([]);
  const [enumDescriptionsList, setEnumDescriptionsList] = useState([]);
  const [characteristicsList, setCharacteristicsList] = useState([]);
  const [variantCharacteristicsList, setVariantCharacteristicsList] = useState([]);


  const scroll = () => {
    const navElement = document.getElementById('navbar');
    navElement.scrollIntoView({ behavior: 'smooth', block: 'start'});
  }

  const handleClick = (event) => {
    setActiveButton(event.target.id);
    scroll();
  }


  const createDescriptionsList = (product) => {
    const descriptions = [];
    if (product.description_paragraph_1) {
      descriptions.push(product.description_paragraph_1);
    }
    if (product.description_paragraph_2) {
      descriptions.push(product.description_paragraph_2);
    }
    if (product.description_paragraph_3) {
      descriptions.push(product.description_paragraph_3);
    }
    if (product.description_paragraph_4) {
      descriptions.push(product.description_paragraph_4);
    }
    if (product.description_paragraph_5) {
      descriptions.push(product.description_paragraph_5);
    }
    return descriptions
  }

  const getEnumValuesList = (object) => {
    let values = [];
    if (Object.keys(object).length > 0) {
      Object.keys(object).forEach(key => {
        if (key.includes('value') && object[key] !== null && object[key] !== '') {
          values.push(object[key]);
        }
      });
    }
    return values;
  }

  const decomposeFiles = (files) => {
    const programs = [];
    const documents = [];
    const certificates = [];
    files.reverse().forEach(file => {
      if (file.type === 'program') {
        programs.push(file);
      } else if (file.type === 'document') {
        documents.push(file);
      } else if (file.type === 'certificate') {
        certificates.push(file);
      }
    });
    setProgramList(programs);
    setDocumentList(documents);
    setCertificateList(certificates);
  }

  useEffect(() => {
    if (product.productfiles_set?.length > 0) {
      decomposeFiles(product.productfiles_set);
    }
    setDescriptionsList(createDescriptionsList(product));
    if (product.enum_descriptions?.length > 0) {
      setEnumDescriptionsList(product.enum_descriptions);
    }
    if (product.productproperty_set?.length > 0) {
      setCharacteristicsList(product.productproperty_set);
    }
  }, [product]);

  useEffect(() => {
    if (variant && variant.property_variants?.length > 0) {
      setVariantCharacteristicsList(variant.property_variants);
    } else {
      setVariantCharacteristicsList([]);
    }
  }, [variant]);


  return (
    <div className={styles.container} id='container'>
      <h2 className={styles.title}>Основная информация:</h2>
      <nav className={styles.navbar} id='navbar'>
        <button id='description' onClick={handleClick}
          className={`${styles.button} ${activeButton === 'description' && styles.button__active}`}
        >Описание</button>
        {product.productproperty_set?.length > 0 &&
          <button id='characteristics' onClick={handleClick}
            className={`${styles.button} ${activeButton === 'characteristics' && styles.button__active}`}
          >Характеристики</button>
        }
        {product.productfiles_set?.length > 0 &&
          <button id='documentation' onClick={handleClick}
            className={`${styles.button} ${activeButton === 'documentation' && styles.button__active}`}
          >Документация и ПО</button>
        }
      </nav>
      {Object.entries(product).length > 0 ?
        <>
          {
            activeButton === 'description' &&
            <div className={styles.contentContainer}>
              <ul className={styles.list}>
                {descriptionsList.map((description, index) => (
                  <li className={styles.item} key={index}>
                    <p className='text text__align'>&emsp;&emsp;{description}</p>
                  </li>
                ))}
                {enumDescriptionsList.map((enumDescription, index) => (
                  <li className={styles.item} key={index}>
                    <p className='text text__bold'>&emsp;&emsp;{enumDescription.name}:</p>
                    <ul className={styles.subList}>
                      {getEnumValuesList(enumDescription).map((value, index) => (
                        <li className={styles.subItem} key={index}>
                          <p className='text'>{`- ${value}${index === getEnumValuesList(enumDescription).length - 1 ? '.' : ';'}`}</p>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          }
          {
            activeButton === 'characteristics' &&
            <div className={styles.charsContainer} id='charsContainer'>
              {
                characteristicsList?.length > 0 &&
                <div className={styles.documentContainer}>
                  <ul className={styles.list}>
                    {characteristicsList.map((item, index) => (
                      <li className={styles.itemChars} key={index}>
                        <p className={`${styles.charsTextLeft}`}>{item.property}:</p>
                        <p className={`${styles.charsTextRight}`}>{item.value}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              }
              {/* тут характеристики варианта товара */}
              {
                variant &&
                variantCharacteristicsList?.length > 0 &&
                <div className={styles.documentContainer}>
                  <p className={styles.subtitle}>Вариант {variant.name}:</p>
                  <ul className={styles.list}>
                    {variantCharacteristicsList.map((item, index) => (
                      <li className={styles.itemChars} key={index}>
                        <p className={`${styles.charsTextLeft}`}>{item.property}:</p>
                        <p className={`${styles.charsTextRight}`}>{item.value}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              }
            </div>
          }
          {
            activeButton === 'documentation' &&
            <div className={styles.contentContainer}>
              <>
                {documentList.length > 0 &&
                  <div className={styles.documentContainer}>
                    <p className={styles.subtitle}>Документация:</p>
                    <ul className={styles.list}>
                      {documentList.map((file, index) => (
                        <li className={styles.item} key={index}>
                          <a href={file.file} className={styles.link}
                            download={file.file.substring(file.file.lastIndexOf("/") + 1, file.file.length)}>
                            <div className={styles.buttonDownload} />
                            {file.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>}
                {programList.length > 0 &&
                  <div className={styles.documentContainer}>
                    <p className={styles.subtitle}>Программное обеспечение:</p>
                    <ul className={styles.list}>
                      {programList.map((file, index) => (
                        <li className={styles.item} key={index}>
                          <a href={file.file} className={styles.link}
                            download={file.file.substring(file.file.lastIndexOf("/") + 1, file.file.length)}>
                            <div className={styles.buttonDownload} />
                            {file.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                }
                {certificateList.length > 0 &&
                  <div className={styles.documentContainer}>
                    <p className={styles.subtitle}>Сертификаты:</p>
                    <ul className={styles.list}>
                      {certificateList.map((file, index) => (
                        <li className={styles.item} key={index}>
                          <a href={file.file} className={styles.link}
                            download={file.file.substring(file.file.lastIndexOf("/") + 1, file.file.length)}>
                            <div className={styles.buttonDownload} />
                            {file.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                }
              </>
            </div>
          }
        </> : null
      }

    </div >
  );
}

export default ProductInfoBar;
